import { Roles } from 'src/common/types'
import type { RouteRecordRaw } from 'vue-router'

const routeRecords: RouteRecordRaw = {
  path: 'journal',
  redirect: { name: 'client.journal.list' },
  meta: {
    roles: [Roles.Client],
    supportedPlatforms: ['desktop', 'mobile', 'native'],
  },
  children: [
    {
      name: 'client.journal.list',
      path: '',
      component: () => import('src/client/pages/ClientJournal.vue'),
      meta: {
        excludeEnv: [],
      },
    },
    {
      name: 'client.journal.signoff',
      path: 'signoff',
      component: () => import('src/client/pages/ClientSignOff.vue'),
      meta: {
        excludeEnv: [],
      },
    },
  ],
}

export default routeRecords
